import React, { useState } from 'react';
import { Modal, Button, Form, Input } from 'antd';
import { createResource } from '../../../redux/resources/actions';
import { useDispatch } from "react-redux";

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

export const AddResource = () => {
    const dispatch = useDispatch();
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();

    const showModal = () => {
        setVisible(true);
    };

    const hideModal_Ok = () => {
        form.submit();
    };

    const form_onfinish = () => {
        let data = form.getFieldsValue();
        dispatch(createResource(data));
        form.resetFields();
        setVisible(false);
    };

    const hideModal_Cancel = () => {
        setVisible(false);
        form.resetFields();
    };

    return (
        <>
            <Button type="primary" onClick={showModal}>
                + Create
            </Button>
            <Modal
                title="Add Resource"
                visible={visible}
                onOk={hideModal_Ok}
                onCancel={hideModal_Cancel}
                okText="Submit"
                cancelText="Close"
            >
                <Form
                    {...layout}
                    name="basic"
                    form={form}
                    onFinish={form_onfinish}
                    initialValues={{ remember: false }}
                >
                    <Form.Item
                        label="Resource Name"
                        name="name"
                        rules={[{ required: true, message: 'Please enter the resource name!' }]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default AddResource;
